import {
  ADD_NEW_REDIRECT,
  FETCH_REDIRECTS,
  REMOVE_REDIRECT_BY_ID,
  FETCH_ALL_REDIRECTS,
  GLOBAL_REDIRECT_UPDATE_STATUS,
  FETCH_REDIRECT_TO_EDIT
} from '../actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_NEW_REDIRECT:
      return {
        ...state,
        ...action.payload
      }
    case FETCH_REDIRECTS:
      return {
        ...state,
        ...action.payload
      }
    case FETCH_ALL_REDIRECTS:
      return {
        ...state,
        ...action.payload
      }
    case FETCH_REDIRECT_TO_EDIT:
      return {
        ...state,
        ...action.payload
      }
    case REMOVE_REDIRECT_BY_ID:
      return {
        ...state,
        ...action.payload
      }
    case GLOBAL_REDIRECT_UPDATE_STATUS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
